import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardApiService } from '@shared/services/api/dashboard/dashboard-api.service';
import { IProducts, ProductUrlFormat } from '@shared/services/api/dashboard/products-service/product-model';
import { SuccessResponse } from '@shared/services/api/legacy/response';
import { map } from 'rxjs';
import '@invitedesk/admin-widgets/product-picker/ivd-product-picker.js';
import { Store } from '@ngrx/store';
import { IState } from '@state/state.module';
import { AuthService } from '@shared/services/auth/auth.service';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss']
})
export class ProductsComponent {
  @Input() tenantId = '';
  @Input() iconColor = '';
  @Output() toggleProduct = new EventEmitter<boolean>();
  constructor(private dashboardApi: DashboardApiService, private store: Store<IState>, private authService: AuthService) {}

  products$ = this.dashboardApi.products.getProducts()
    .pipe(map((response: SuccessResponse<IProducts>) => {
      const tenantId = this.authService.retrieveToken()?.decoded?.ten;
      const products = response.data.products.map((product) => {
      if (product.productUrlFormat === ProductUrlFormat.Engage) {
        const page = product.name.toLowerCase().includes('datahub') ? 'fill-rate' : 'events';
        return {
          ...product,
          absoluteUrl: `${product.baseUrl}/login-backdoor?tenantid=${tenantId}&page=${encodeURIComponent(page)}`,
        };
      } else {
        return {
          ...product,
          absoluteUrl: `${product.baseUrl}${product.landingPageRelativeUrl}${tenantId ? `?tenant=${tenantId}` : ''}`,
        };
      }
    });
    return products;
  }));
  language$ = this.store.select(x => x.app).pipe(map(profile => profile.profile.languageId));

}
